// extracted by mini-css-extract-plugin
export var box = "_8h-1";
export var checkboxRow = "_8h-8";
export var checked = "_8h-2";
export var descriptionSpacer = "_8h-a";
export var disabled = "_8h-3";
export var icon = "_8h-6";
export var input = "_8h-0";
export var labelSpacer = "_8h-9";
export var medium = "_8h-5";
export var small = "_8h-4";
export var text = "_8h-7";